function PadLeft(value, length) {
    return value.toString().length < length
      ? PadLeft("0" + value, length)
      : value;
  }
  export default PadLeft; 